import { render, staticRenderFns } from "./ComparativeTable.vue?vue&type=template&id=d5fca498&scoped=true"
import script from "./ComparativeTable.vue?vue&type=script&lang=js"
export * from "./ComparativeTable.vue?vue&type=script&lang=js"
import style0 from "./ComparativeTable.vue?vue&type=style&index=0&id=d5fca498&prod&lang=scss&scoped=true"
import style1 from "./ComparativeTable.vue?vue&type=style&index=1&id=d5fca498&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fca498",
  null
  
)

export default component.exports